<template>
	<div class="mainBox">
		<div class="m_title">个人信息</div>
		<el-form ref="updateForm" :model="member" label-width="100px" class='updatePasd_form'>
			<el-form-item prop='name' label='账号：'>
				{{member.username}}
			</el-form-item>
			<el-form-item prop='name' label='真实姓名：'>
				{{member.realname}}
			</el-form-item>
			<el-form-item prop='email' label='邮箱：'>
				{{member.email}}
			</el-form-item>
			<el-form-item prop='name' label='状态：'>
				<span v-if="member.status === 'active'">激活</span>
				<span v-else>冻结</span>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		name: "userinfo",
		data() {
			return {
				updateForm:{}
			}
		},
		computed:{
			...mapState([
				'member'
			])
		},
		methods: {}
	}
</script>

<style scoped="scoped">
	.m_title{border-bottom:2px solid #999;line-height:40px;margin-bottom:30px;padding-left:15px;position:relative;}
	.m_title:before{position: absolute;left:0;top:20%;width:3px;height:60%;background:#1876EF;content: "";}
	.updatePasd_form{width:50%;}
</style>
